import Account from '../../../../../services/account'

export default {
  props: ['address'],
  data() {
    return {
      loadingAddress: undefined,
      zipCode: undefined,
      address2: undefined,
      number: undefined,
      neighborhood: undefined,
      complement: undefined,
      city: undefined,
      state: undefined
    }
  },
  mounted() {
    if(this.address) {
      this.loadingAddress = this.address.loadingAddress;
      this.zipCode = this.address.zipCode;
      this.address2 = this.address.address;
      this.number = this.address.number;
      this.neighborhood = this.address.neighborhood;
      this.complement = this.address.complement;
      this.city = this.address.city;
      this.state = this.address.state;
    }
  },
  methods: {
    async queryAddress() {
      this.errorCep = undefined;
      this.loadingAddress = Account.queryAddress(this.zipCode).then(res => {
          this.address2 = res.address;
          this.city = res.city;
          this.neighborhood = res.neighborhood;
          this.state = res.state;
          this.zipCode = res.zipCode;

          if(this.address2.length == 0 && this.neighborhood.length == 0) {
            this.number='';
          }
        })
        .catch((err) => {
          this.errorCep = err.data.status.message;
          this.$validator.validateAll();
        });
    },
    validateAll(){
      return this.$validator.validateAll().then( _ => {
        this.address.loadingAddress =  this.loadingAddress;
        this.address.zipCode = this.zipCode;
        this.address.address = this.address2;
        this.address.number = this.number;
        this.address.neighborhood = this.neighborhood;
        this.address.complement = this.complement;
        this.address.city = this.city;
        this.address.state = this.state;
      });
    },
    queryAddressTyping(){

      if(this.zipCode.length < 8)
        return;

      this.queryAddress();
    }
  },
}



// WEBPACK FOOTER //
// ./src/pages/account/aggregate/modal/aggregate-register/address.js